import { ViewPortType } from '@/engine/app/interfaces.ts';

export const viewPorts: Array<ViewPortType> = [
  ViewPortType.Coronal,
  ViewPortType.Axial,
  ViewPortType.Sagittal,
  ViewPortType.ThreeD
];
